// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zephr-block-preview{border:1px solid #ccc;padding:1rem}", "",{"version":3,"sources":["webpack://./blocks/feature-block/style.scss"],"names":[],"mappings":"AAAA,qBACE,qBAAA,CACA,YAAA","sourcesContent":[".zephr-block-preview {\n  border: 1px solid #ccc;\n  padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
